// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/garage/Garage.css */

/* Глобальный контейнер на весь экран */
.garage-container {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #0f172a; /* Темный фон всего экрана */
  font-family: 'Courier New', monospace;
  z-index: 6000;
  padding: 10px;
  box-sizing: border-box;
}

/* Игровая доска (Квадрат) */
.garage-board {
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1 / 1;
  background: #1e272e;
  border: 4px solid #2c3e50;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  position: relative;
  overflow: hidden;
  margin-bottom: 20px; /* Отступ до кнопок */
  flex-shrink: 0;
}

/* ЗАГОЛОВОК ВНУТРИ ДОСКИ */
.garage-header {
  position: absolute;
  top: 10px; left: 10px; right: 10px;
  display: flex; justify-content: space-between;
  z-index: 100;
}

.garage-badge {
  background: rgba(0,0,0,0.8);
  color: #fbbf24;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 14px;
}

/* ГАРАЖ */
.garage-building {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 40%; height: 40%;
  /* Более технологичный вид */
  background:
    linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
  border: 4px solid #7f8c8d;
  border-radius: 4px;
  z-index: 20;
  box-shadow: 0 10px 25px rgba(0,0,0,0.9);
  display: flex; align-items: center; justify-content: center;
}

.garage-building::after {
  content: 'GARAGE';
  font-size: 1rem;
  font-weight: 900;
  color: rgba(255,255,255,0.15);
  transform: rotate(-45deg);
  letter-spacing: 2px;
}

/* ВОРОТА (ГЕЙТЫ) */
.garage-gate-marker {
  position: absolute;
  background: #111;
  border: 1px solid #555;
  /* Текстура ворот */
  background-image: repeating-linear-gradient(90deg, transparent, transparent 2px, #333 2px, #333 4px);
}

.gate-m-top { top: -8px; left: 25%; width: 50%; height: 8px; border-bottom: none; border-radius: 2px 2px 0 0; }
.gate-m-bottom { bottom: -8px; left: 25%; width: 50%; height: 8px; border-top: none; border-radius: 0 0 2px 2px; }
.gate-m-left { left: -8px; top: 25%; height: 50%; width: 8px; border-right: none; background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, #333 2px, #333 4px); border-radius: 2px 0 0 2px; }
.gate-m-right { right: -8px; top: 25%; height: 50%; width: 8px; border-left: none; background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, #333 2px, #333 4px); border-radius: 0 2px 2px 0; }

/* ДОРОГИ С ПУНКТИРОМ */
.garage-road {
  position: absolute;
  background: #34495e;
  opacity: 0.6;
  z-index: 1;
}

.road-v {
  width: 22%; /* Чуть шире для больших машин */
  height: 100%;
  left: 39%; /* Центрируем (50 - 11) */
  top: 0;
  /* Белый пунктир по центру */
  background-image: linear-gradient(to bottom, #34495e 0%, #34495e 50%),
                    linear-gradient(to bottom, rgba(255,255,255,0.4) 50%, transparent 50%);
  background-size: 100% 100%, 2px 20px; /* Ширина линии 2px, шаг 20px */
  background-position: center;
  background-repeat: no-repeat, repeat-y;
}

.road-h {
  width: 100%;
  height: 22%;
  top: 39%;
  left: 0;
  background-image: linear-gradient(to right, #34495e 0%, #34495e 50%),
                    linear-gradient(to right, rgba(255,255,255,0.4) 50%, transparent 50%);
  background-size: 100% 100%, 20px 2px;
  background-position: center;
  background-repeat: no-repeat, repeat-x;
}

/* МАШИНА (SVG) */
.garage-car-wrapper {
  position: absolute;
  width: 50px; height: 50px; /* БОЛЬШИЕ МАШИНЫ */
  display: flex; align-items: center; justify-content: center;
  z-index: 10; /* Ниже гаража */
  /* УДАЛЕНО: transition: transform 0.1s linear; */
  /* Оставляем только transition opacity для плавного появления */
  transition: opacity 0.1s ease-in;
}

.garage-vehicle {
  width: 100%; height: 100%;
  filter: drop-shadow(0 4px 4px rgba(0,0,0,0.6));
}

/* Цвета заливки SVG (fill="currentColor") */
.car-red { color: #ef4444; }
.car-blue { color: #3b82f6; }
.car-green { color: #22c55e; }
.car-yellow { color: #fbbf24; }
.car-white { color: #fff; }

/* НИЖНЯЯ ПАНЕЛЬ С ВОПРОСОМ (Отдельный блок) */
.garage-bottom-panel {
  width: 100%;
  max-width: 400px;
  background: #1e293b;
  border-radius: 8px;
  padding: 15px;
  border: 1px solid #334155;
  animation: fadeIn 0.3s ease-out;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.gb-question-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}

.gb-icon-wrapper {
  width: 50px; height: 50px;
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
  padding: 5px;
}

.gb-options-row {
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.gb-btn {
  flex: 1 1;
  background: #fbbf24;
  color: #0f172a;
  border: none;
  border-radius: 8px;
  padding: 15px 0;
  font-size: 24px;
  font-weight: 900;
  cursor: pointer;
  box-shadow: 0 4px 0 #b45309;
  transition: transform 0.1s;
}
.gb-btn:active { transform: translateY(4px); box-shadow: 0 0 0 #b45309; }

/* Плейсхолдер, пока нет вопроса */
.garage-bottom-placeholder {
  width: 100%;
  max-width: 400px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
  font-style: italic;
  padding: 20px;
}

/* ФИДБЕК ОВЕРЛЕЙ (Внутри доски) */
.garage-feedback {
  position: absolute; inset: 0;
  background: rgba(0,0,0,0.85);
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  z-index: 200;
  animation: fadeIn 0.2s;
}
.gf-icon { font-size: 60px; margin-bottom: 10px; }
.gf-text { font-size: 24px; font-weight: 900; color: #fff; }
.gf-sub { font-size: 16px; color: #aaa; margin-top: 5px; }
.gf-success { color: #2ecc71; }
.gf-error { color: #e74c3c; }

/* Яркий круг для вопроса о цвете */
.gq-pure-blob {
  width: 100%;
  height: 100%;
  border-radius: 50%;

  /* Используем currentColor, который задается классами .car-red, .car-blue ... */
  background-color: currentColor;

  /* Добавляем тень того же цвета для свечения/яркости */
  box-shadow: 0 0 10px currentColor;

  /* Небольшая рамка для контраста, если цвет темный, но в целом необязательно */
  border: 2px solid rgba(255,255,255,0.2);
  box-sizing: border-box;
}

/* Убедимся, что цвета машин определены (они уже есть в файле, просто напоминание) */
.car-red { color: #ef4444; }
.car-blue { color: #3b82f6; }
.car-green { color: #22c55e; }
.car-yellow { color: #fbbf24; }
.car-white { color: #fff; }

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/garage/Garage.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB,EAAE,4BAA4B;EACjD,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,qBAAqB;EAC1C,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,SAAS,EAAE,UAAU,EAAE,WAAW;EAClC,aAAa,EAAE,8BAA8B;EAC7C,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,gCAAgC;EAChC,UAAU,EAAE,WAAW;EACvB,4BAA4B;EAC5B;qDACmD;EACnD,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,uCAAuC;EACvC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,oGAAoG;AACtG;;AAEA,cAAc,SAAS,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE,0BAA0B,EAAE;AAC9G,iBAAiB,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACjH,eAAe,UAAU,EAAE,QAAQ,EAAE,WAAW,EAAE,UAAU,EAAE,kBAAkB,EAAE,mGAAmG,EAAE,0BAA0B,EAAE;AACnN,gBAAgB,WAAW,EAAE,QAAQ,EAAE,WAAW,EAAE,UAAU,EAAE,iBAAiB,EAAE,mGAAmG,EAAE,0BAA0B,EAAE;;AAEpN,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU,EAAE,gCAAgC;EAC5C,YAAY;EACZ,SAAS,EAAE,yBAAyB;EACpC,MAAM;EACN,4BAA4B;EAC5B;0FACwF;EACxF,oCAAoC,EAAE,+BAA+B;EACrE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,QAAQ;EACR,OAAO;EACP;yFACuF;EACvF,oCAAoC;EACpC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,WAAW,EAAE,gBAAgB;EAC7B,gDAAgD;EAChD,+DAA+D;EAC/D,gCAAgC;AAClC;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,8CAA8C;AAChD;;AAEA,4CAA4C;AAC5C,WAAW,cAAc,EAAE;AAC3B,YAAY,cAAc,EAAE;AAC5B,aAAa,cAAc,EAAE;AAC7B,cAAc,cAAc,EAAE;AAC9B,aAAa,WAAW,EAAE;;AAE1B,8CAA8C;AAC9C;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA,iBAAiB,0BAA0B,EAAE,yBAAyB,EAAE;;AAExE,kCAAkC;AAClC;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,kBAAkB,EAAE,QAAQ;EAC5B,4BAA4B;EAC5B,aAAa,EAAE,sBAAsB;EACrC,mBAAmB,EAAE,uBAAuB;EAC5C,YAAY;EACZ,sBAAsB;AACxB;AACA,WAAW,eAAe,EAAE,mBAAmB,EAAE;AACjD,WAAW,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAC3D,UAAU,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;AACzD,cAAc,cAAc,EAAE;AAC9B,YAAY,cAAc,EAAE;;AAE5B,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,+EAA+E;EAC/E,8BAA8B;;EAE9B,sDAAsD;EACtD,iCAAiC;;EAEjC,8EAA8E;EAC9E,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,oFAAoF;AACpF,WAAW,cAAc,EAAE;AAC3B,YAAY,cAAc,EAAE;AAC5B,aAAa,cAAc,EAAE;AAC7B,cAAc,cAAc,EAAE;AAC9B,aAAa,WAAW,EAAE;;AAE1B,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE","sourcesContent":["/* games/garage/Garage.css */\r\n\r\n/* Глобальный контейнер на весь экран */\r\n.garage-container {\r\n  position: fixed;\r\n  top: 0; left: 0; width: 100%; height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #0f172a; /* Темный фон всего экрана */\r\n  font-family: 'Courier New', monospace;\r\n  z-index: 6000;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Игровая доска (Квадрат) */\r\n.garage-board {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  aspect-ratio: 1 / 1;\r\n  background: #1e272e;\r\n  border: 4px solid #2c3e50;\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.5);\r\n  position: relative;\r\n  overflow: hidden;\r\n  margin-bottom: 20px; /* Отступ до кнопок */\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ЗАГОЛОВОК ВНУТРИ ДОСКИ */\r\n.garage-header {\r\n  position: absolute;\r\n  top: 10px; left: 10px; right: 10px;\r\n  display: flex; justify-content: space-between;\r\n  z-index: 100;\r\n}\r\n\r\n.garage-badge {\r\n  background: rgba(0,0,0,0.8);\r\n  color: #fbbf24;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n}\r\n\r\n/* ГАРАЖ */\r\n.garage-building {\r\n  position: absolute;\r\n  top: 50%; left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 40%; height: 40%;\r\n  /* Более технологичный вид */\r\n  background:\r\n    linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);\r\n  border: 4px solid #7f8c8d;\r\n  border-radius: 4px;\r\n  z-index: 20;\r\n  box-shadow: 0 10px 25px rgba(0,0,0,0.9);\r\n  display: flex; align-items: center; justify-content: center;\r\n}\r\n\r\n.garage-building::after {\r\n  content: 'GARAGE';\r\n  font-size: 1rem;\r\n  font-weight: 900;\r\n  color: rgba(255,255,255,0.15);\r\n  transform: rotate(-45deg);\r\n  letter-spacing: 2px;\r\n}\r\n\r\n/* ВОРОТА (ГЕЙТЫ) */\r\n.garage-gate-marker {\r\n  position: absolute;\r\n  background: #111;\r\n  border: 1px solid #555;\r\n  /* Текстура ворот */\r\n  background-image: repeating-linear-gradient(90deg, transparent, transparent 2px, #333 2px, #333 4px);\r\n}\r\n\r\n.gate-m-top { top: -8px; left: 25%; width: 50%; height: 8px; border-bottom: none; border-radius: 2px 2px 0 0; }\r\n.gate-m-bottom { bottom: -8px; left: 25%; width: 50%; height: 8px; border-top: none; border-radius: 0 0 2px 2px; }\r\n.gate-m-left { left: -8px; top: 25%; height: 50%; width: 8px; border-right: none; background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, #333 2px, #333 4px); border-radius: 2px 0 0 2px; }\r\n.gate-m-right { right: -8px; top: 25%; height: 50%; width: 8px; border-left: none; background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, #333 2px, #333 4px); border-radius: 0 2px 2px 0; }\r\n\r\n/* ДОРОГИ С ПУНКТИРОМ */\r\n.garage-road {\r\n  position: absolute;\r\n  background: #34495e;\r\n  opacity: 0.6;\r\n  z-index: 1;\r\n}\r\n\r\n.road-v {\r\n  width: 22%; /* Чуть шире для больших машин */\r\n  height: 100%;\r\n  left: 39%; /* Центрируем (50 - 11) */\r\n  top: 0;\r\n  /* Белый пунктир по центру */\r\n  background-image: linear-gradient(to bottom, #34495e 0%, #34495e 50%),\r\n                    linear-gradient(to bottom, rgba(255,255,255,0.4) 50%, transparent 50%);\r\n  background-size: 100% 100%, 2px 20px; /* Ширина линии 2px, шаг 20px */\r\n  background-position: center;\r\n  background-repeat: no-repeat, repeat-y;\r\n}\r\n\r\n.road-h {\r\n  width: 100%;\r\n  height: 22%;\r\n  top: 39%;\r\n  left: 0;\r\n  background-image: linear-gradient(to right, #34495e 0%, #34495e 50%),\r\n                    linear-gradient(to right, rgba(255,255,255,0.4) 50%, transparent 50%);\r\n  background-size: 100% 100%, 20px 2px;\r\n  background-position: center;\r\n  background-repeat: no-repeat, repeat-x;\r\n}\r\n\r\n/* МАШИНА (SVG) */\r\n.garage-car-wrapper {\r\n  position: absolute;\r\n  width: 50px; height: 50px; /* БОЛЬШИЕ МАШИНЫ */\r\n  display: flex; align-items: center; justify-content: center;\r\n  z-index: 10; /* Ниже гаража */\r\n  /* УДАЛЕНО: transition: transform 0.1s linear; */\r\n  /* Оставляем только transition opacity для плавного появления */\r\n  transition: opacity 0.1s ease-in;\r\n}\r\n\r\n.garage-vehicle {\r\n  width: 100%; height: 100%;\r\n  filter: drop-shadow(0 4px 4px rgba(0,0,0,0.6));\r\n}\r\n\r\n/* Цвета заливки SVG (fill=\"currentColor\") */\r\n.car-red { color: #ef4444; }\r\n.car-blue { color: #3b82f6; }\r\n.car-green { color: #22c55e; }\r\n.car-yellow { color: #fbbf24; }\r\n.car-white { color: #fff; }\r\n\r\n/* НИЖНЯЯ ПАНЕЛЬ С ВОПРОСОМ (Отдельный блок) */\r\n.garage-bottom-panel {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  background: #1e293b;\r\n  border-radius: 8px;\r\n  padding: 15px;\r\n  border: 1px solid #334155;\r\n  animation: fadeIn 0.3s ease-out;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.gb-question-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n}\r\n\r\n.gb-icon-wrapper {\r\n  width: 50px; height: 50px;\r\n  background: rgba(255,255,255,0.1);\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n}\r\n\r\n.gb-options-row {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: space-between;\r\n}\r\n\r\n.gb-btn {\r\n  flex: 1;\r\n  background: #fbbf24;\r\n  color: #0f172a;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 15px 0;\r\n  font-size: 24px;\r\n  font-weight: 900;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 0 #b45309;\r\n  transition: transform 0.1s;\r\n}\r\n.gb-btn:active { transform: translateY(4px); box-shadow: 0 0 0 #b45309; }\r\n\r\n/* Плейсхолдер, пока нет вопроса */\r\n.garage-bottom-placeholder {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  text-align: center;\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-style: italic;\r\n  padding: 20px;\r\n}\r\n\r\n/* ФИДБЕК ОВЕРЛЕЙ (Внутри доски) */\r\n.garage-feedback {\r\n  position: absolute; inset: 0;\r\n  background: rgba(0,0,0,0.85);\r\n  display: flex; flex-direction: column;\r\n  align-items: center; justify-content: center;\r\n  z-index: 200;\r\n  animation: fadeIn 0.2s;\r\n}\r\n.gf-icon { font-size: 60px; margin-bottom: 10px; }\r\n.gf-text { font-size: 24px; font-weight: 900; color: #fff; }\r\n.gf-sub { font-size: 16px; color: #aaa; margin-top: 5px; }\r\n.gf-success { color: #2ecc71; }\r\n.gf-error { color: #e74c3c; }\r\n\r\n/* Яркий круг для вопроса о цвете */\r\n.gq-pure-blob {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n\r\n  /* Используем currentColor, который задается классами .car-red, .car-blue ... */\r\n  background-color: currentColor;\r\n\r\n  /* Добавляем тень того же цвета для свечения/яркости */\r\n  box-shadow: 0 0 10px currentColor;\r\n\r\n  /* Небольшая рамка для контраста, если цвет темный, но в целом необязательно */\r\n  border: 2px solid rgba(255,255,255,0.2);\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Убедимся, что цвета машин определены (они уже есть в файле, просто напоминание) */\r\n.car-red { color: #ef4444; }\r\n.car-blue { color: #3b82f6; }\r\n.car-green { color: #22c55e; }\r\n.car-yellow { color: #fbbf24; }\r\n.car-white { color: #fff; }\r\n\r\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
